import React, { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { createRippleEffectRelative } from '../../../Utils/helper';
import {
  addTocartBogoHandler,
  cartOpenHandlerForBogo,
} from '../../../Utils/productAction';
import { getProductIds } from '../../StoreHomePage/BogoClothDiaper/common';
import { fireProceedToCartEvent } from '../../StoreHomePage/BogoClothDiaper/instrumentation';
import { AnimatedGif } from '../../StoreHomePage/BogoClothDiaper/styled';
import {
  FlexBox,
  GifContainer,
  ProceedButton,
  StickySelectDiaperCTA,
} from './styled';
import OfferStripVarientLive from '../OfferStripB2G1/OfferStripVarientLive';
import DaiperPageBottomVarientLive from '../DaiperPageBottomSection/DaiperPageBottomVarientLive';
import { updatedExperimentUserType } from '../DiaperPageRadioOptions/utils';
import Cookies from 'js-cookie';
import { coupon_names } from '../DiaperPageRadioOptions/constant';

export default React.memo(function SelectDiaperButton(props) {
  const {
    offerCartData,
    setShowAnimation,
    setOfferCartData,
    option,
    isForNewCdPage,
    lockedProductSectionRef,
    setShowLockedProductsAnimation,
    setShowHeader,
    setShowTop,
    nonFreebieProductCount,
  } = props;
  let { experimentUserType } = props;
  experimentUserType = updatedExperimentUserType(experimentUserType);

  const diaperproceedbtn = useRef();
  const remainingProductQuantity =
    offerCartData?.offerData?.remainingProductQuantity;
  const array = [];
  const [items, setItems] = useState();
  const [offerAppliedAnimation, setOfferAnimation] = useState(false);
  const pageLocation = 'B2G1';
  useEffect(() => {
    if (offerCartData?.offerData?.offerApplicable) {
      updateCouponValue();
      setOfferAnimation(true);
      // do not apply FReebie in diaper page
      cartOpenHandlerForBogo(pageLocation);
      setTimeout(() => {
        setOfferAnimation(false);
      }, 1500);
    }
  }, [offerCartData?.offerData?.offerApplicable]);

  const clickAnimationHandler = (scrollToLockedProducts = false) => {
    if (scrollToLockedProducts && nonFreebieProductCount >= 2) {
      const element = lockedProductSectionRef.current;
      const offset = 70;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
      });
      setShowLockedProductsAnimation(true);
      setTimeout(() => {
        setShowLockedProductsAnimation(false);
        setShowHeader('-56px');
        setShowTop(true);
      }, 1000);
    } else {
      document.getElementById(`twoGrid`)?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
      });
      setShowAnimation(true);
      setTimeout(() => {
        setShowAnimation(false);
      }, 1000);
    }
  };

  const proceedToPayHandler = (isForNewCdPage = false) => {
    if (offerCartData?.offerData?.offerApplicable) {
      fireProceedToCartEvent(
        offerCartData?.productList?.[0],
        offerCartData?.offerData?.offerCode,
      );
      // do not apply FReebie in diaper page
      cartOpenHandlerForBogo(pageLocation);
      updateCouponValue();
    } else {
      if (isForNewCdPage) {
        if (items.length >= 2 && nonFreebieProductCount >= 2) {
          const element = lockedProductSectionRef.current;
          const offset = 70;
          const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth',
          });

          setShowLockedProductsAnimation(true);
          setTimeout(() => {
            setShowLockedProductsAnimation(false);
            setShowHeader('-56px');
            setShowTop(true);
          }, 1000);
        } else {
          clickAnimationHandler();
        }
      } else {
        clickAnimationHandler();
      }
    }
  };

  const addRemoveItemsHandler = async (productId) => {
    let params = {};
    params = {
      productId: productId,
      ids: getProductIds(offerCartData?.productList),
      add: false,
      less: true,
      addToCart: false,
    };

    const data = await addTocartBogoHandler(params);
    setOfferCartData(data?.data);
  };
  const updateCouponValue = () => {
    let coupon_to_apply = isForNewCdPage
      ? coupon_names.b2g1New
      : coupon_names?.b2g1;
    if (option === '3') coupon_to_apply = coupon_names?.b3g2;
    Cookies.set('coupon_code', coupon_to_apply);
  };

  useEffect(() => {
    offerCartData?.productList?.map((element) => {
      let obj = {};
      if (!element?.addToCart) {
        if (element?.quantity > 1) {
          for (let i = 1; i < element?.quantity; i++) {
            obj = {
              image: element?.image,
              id: element?.id,
            };
            array.push(obj);
          }
        }
        obj = {
          image: element?.image,
          id: element?.id,
        };
        array.push(obj);
      }
    });
    setItems(array);
  }, [offerCartData?.productList]);

  const getOfferText = () => {
    return (
      <OfferStripVarientLive
        remainingProductQuantity={remainingProductQuantity}
        clickAnimationHandler={clickAnimationHandler}
        offerCartData={offerCartData}
        isForNewCdPage={isForNewCdPage}
      />
    );
  };

  const getProceedButtonSection = (experimentUserType) => {
    return (
      <DaiperPageBottomVarientLive
        items={items}
        addRemoveItemsHandler={addRemoveItemsHandler}
        clickAnimationHandler={clickAnimationHandler}
        isForNewCdPage={isForNewCdPage}
      />
    );
  };

  return (
    <StickySelectDiaperCTA>
      {getOfferText(experimentUserType)}
      <FlexBox
        showMargin={items?.[0]?.image}
        experimentUserType={experimentUserType}
      >
        {getProceedButtonSection(experimentUserType)}

        <ProceedButton
          ref={diaperproceedbtn}
          proceed={offerCartData?.offerData?.offerApplicable}
          onClick={(event) => {
            createRippleEffectRelative(event, diaperproceedbtn.current);
            proceedToPayHandler(isForNewCdPage);
          }}
        >
          View Cart
          <img src={images.arrowWhite} alt="" />
        </ProceedButton>
      </FlexBox>
      {offerAppliedAnimation && (
        <GifContainer>
          <AnimatedGif src={images.confettiGif} alt="animatedGif" />
        </GifContainer>
      )}
    </StickySelectDiaperCTA>
  );
});
